import {
  Button,
  Checkbox,
  InputAdornment,
  ListItemText,
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';
import React from 'react';
import DateTimeRangePicker, {
  DateTimeRangePickerProps,
} from '../../../commons/DateTimeRangePicker/DateTimeRangePicker';
import { TimeFrame } from '../../../../redux/monitoring/api/monitoring-ui.model';
import { getPolyglot } from '../../../../i18n';
import ReportAPI from '../../../../redux/reports/api/ReportAPI';
import { useAppSelector } from '../../../../redux/store.model';
import { getMyWorkspaceIdSelector } from '../../../../redux/stoerkID/selectors/StoerkId.selectors';
import { skipToken } from '@reduxjs/toolkit/query';
import { FilterListIcon } from '../../../../theme/icons';
import RefreshIcon from '@mui/icons-material/Refresh';

interface ReportFiltersProps {
  timeFrame?: TimeFrame;
  onChangeDatePicker: DateTimeRangePickerProps['onChange'];
  reportTypeIds?: string[];
  onChangeReportTypes?: (reportTypeIds: string[]) => void;
  refetchReports: () => void;
}

function ReportFilters(props: ReportFiltersProps) {
  const polyglot = getPolyglot();
  const workspaceId = useAppSelector(getMyWorkspaceIdSelector);
  const {
    reportTypeIds,
    onChangeReportTypes,
    timeFrame,
    onChangeDatePicker,
    refetchReports,
  } = props;
  const {
    data: reportTypes,
    isLoading: isLoadingReportTypes,
    ...rest
  } = ReportAPI.useGetReportTypesQuery(workspaceId ?? skipToken);

  return (
    <Stack spacing={2} mb={2} direction={{ xs: 'column', sm: 'row' }}>
      {/* <TextField
        select
        SelectProps={{
          multiple: true,
          renderValue: (selected: any) =>
            `${polyglot.t('reports.table.type')} (${selected?.length}/${
              reportTypes?.length || 0
            })`,
        }}
        label={polyglot.t('reports.table.type')}
        sx={{ minWidth: 300 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FilterListIcon />
            </InputAdornment>
          ),
        }}
        value={reportTypeIds || []}
        onChange={(event, ...rest) => {
          if (onChangeReportTypes)
            onChangeReportTypes(event.target.value as unknown as string[]);
        }}
      >
        {reportTypes?.map((reportType) => (
          <MenuItem key={reportType.id} value={reportType.id}>
            <Checkbox
              checked={
                (reportTypeIds?.findIndex((item) => item === reportType?.id) ??
                  -1) >= 0
              }
            />
            <ListItemText primary={reportType.name} />
          </MenuItem>
        )) ?? <MenuItem value={''}></MenuItem>}
      </TextField>
      <DateTimeRangePicker
        onChange={onChangeDatePicker}
        placeholder={polyglot.t('reports.period')}
      /> */}

      <Button
        onClick={refetchReports}
        variant="outlined"
        startIcon={<RefreshIcon />}
      >
        {polyglot.t('button.refresh')}
      </Button>
    </Stack>
  );
}

export default ReportFilters;
